import img1 from '@/public/images/landing/hero/1.webp';
import img2 from '@/public/images/landing/hero/2.webp';
import img3 from '@/public/images/landing/hero/3.webp';
import img4 from '@/public/images/landing/hero/4.webp';
import img5 from '@/public/images/landing/hero/5.webp';

export const heroData = [
	{
		id: 1,
		img: img1,
		alt: 'erase feature',
	},
	{
		id: 2,
		img: img2,
		alt: 'caption feature',
	},
	{
		id: 3,
		img: img3,
		alt: 'AI background feature',
	},
	{
		id: 4,
		img: img4,
		alt: 'crop feature',
	},
	{
		id: 5,
		img: img5,
		alt: 'stories maker feature',
	},
];
